"use client";
import React, { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

export const Search = ({
  onChange,
  onEnter,
  onClear,
}: {
  onChange?: (query: string) => void;
  onEnter?: (query: string) => void;
  onClear?: () => void;
}) => {
  const [query, setQuery] = useState("");
  function onInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    setQuery(event.target.value);
    if (onChange) {
      onChange(query);
    }
    if (onClear && event.target.value === "") {
      onClear();
    }
  }
  function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (onEnter && query) {
      onEnter(query);
    }
  }

  return (
    <>
      <form
        className="flex justify-start items-center"
        action="#"
        method="GET"
        onSubmit={onSubmit}>
        <label htmlFor="search" className="sr-only">
          Search
        </label>
        <MagnifyingGlassIcon
          className="h-4 w-4 text-slate-400"
          aria-hidden="true"
        />
        <input
          id="search"
          className="h-full w-full border-0 text-dark placeholder:text-zinc-400 focus:ring-0 text-sm"
          placeholder="Search..."
          type="search"
          name="search"
          value={query}
          onChange={onInputChange}
          onKeyDown={() => onSubmit}
        />
      </form>
    </>
  );
};
